import Component from './component'
import EnhanceRedirectToDefaultPage from './enhancers/EnhanceRedirectToDefaultPage'

export default EnhanceRedirectToDefaultPage(Component)
